const components = require('../components/index')

const initialize = () => {

}

module.exports = {
  initialize: initialize
}
